export default __webpack_public_path__ + "static/media/astronauta-1.52d1757e.png";